import React, { useContext } from 'react'

import Breadcrumbs from '@mui/material/Breadcrumbs'

import Link from '../Link'
import ProfileContext from '@/components/Context/ProfileContext'

type Props = {
  page: string
  getListRoutes: any
  router: any
}

const AccountBreadcrumb: React.FC<Props> = ({ page, getListRoutes, router }) => {
  const path = [{ route: 'Dashboard', text: 'web_mon_compte', complement: '', values: {} }]
  const { profile } = useContext(ProfileContext)
  const tabPage = page.split('[')

  path.push(
    getListRoutes
      .filter(i => (i?.displayMenuAccount && i.displayMenuAccount({ profile })) || !!i.menuAccount)
      .sort((a, b) => {
        if (a.order < b.order) return -1
        if (a.order > b.order) return 1
        return 0
      })
      .find(r => {
        const regexNameRoute = new RegExp(
          r.href.replace(/[!@#$%^&*()+=\-[\]\\';,./{}|":<>?~_]/gi, '\\$&'),
          'i'
        )
        return regexNameRoute.test(router['route'])
      })
  )

  const regexNumOrder = new RegExp('numOrder', 'i')
  if (regexNumOrder.test(tabPage[1])) {
    const complement = {
      route: 'DetailOrder',
      values: { '[numOrder]': router.query.numOrder },
      text: 'web_espace_client_numero_commandes',
      complement: `N° ${router.query.numOrder}`,
    }
    path.push(complement)
  }
  return (
    <Breadcrumbs separator="›" aria-label="breadcrumb">
      <Link route={'Home'}>{t({ id: 'web_accueil' })}</Link>
      {path.length &&
        path.map(cat => (
          <Link key={cat.text} route={cat.route} values={cat.values}>
            {t({ id: cat.text })}
            {!!cat.complement && cat.complement}
          </Link>
        ))}
    </Breadcrumbs>
  )
}

export default AccountBreadcrumb
